import AppRoute from "./routes/router";
import ErrorBoundary from "modules/shared/components/ErrorBoundary";
import { ConfigProvider, Result } from "antd";
import "../src/assets/css/appStyle.css";
import "../src/assets/css/custom.css";
import "../src/assets/css/ant-custom.css";
import "../src/assets/css/dev-temp-custom.css";
import { useEffect, useLayoutEffect, useState } from "react";
import {
  DisconnectOutlined
} from '@ant-design/icons';
import Prompt from "modules/shared/components/accessibility/Prompt";
import { hotjar } from 'react-hotjar';


function App() {

  const [online, setOnline] = useState(true);
  const [_, setIsHotjarInitialized] = useState(false);

  useEffect(() => {
    if(process.env.REACT_APP_HOTJAR_ID && process.env.REACT_APP_HOTJAR_SV){
      hotjar.initialize(parseInt(process.env.REACT_APP_HOTJAR_ID), parseInt(process.env.REACT_APP_HOTJAR_SV));
      setIsHotjarInitialized(true);
      console.log('Hotjar initialized');
    }
    else{
      console.log('Hotjar not initialized');
    }

    const script = document.createElement('script');

    if(['qa'].includes(process.env.REACT_APP_ENVIRONMENT??'')){
      script.src='https://cdn.staging-script.jotgo.io/releases/1.0/pnc-script.js'; // replace with your script URL
      script.async = true;
      script.setAttribute('data-pnc-key', '2rFHk+ccmEzCTKdX7IuDxmm42EX0Wx2F+hGuN7D24wiju7ygqfWbLF2Oudl6zfSU5DoRE3fHcYtI2JANx1PLkBrMbQFzSnBALSJtc5tISvjEMG4W92CGwpkEmALD6JAf');
      document.body.appendChild(script);
    }

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  

  useLayoutEffect(() => {

    function handleEvents(value: boolean) {
      setOnline(value)
    }

    window.addEventListener('online', () => handleEvents(true));
    window.addEventListener('offline', () => handleEvents(false));

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('online', () => handleEvents(true));
      window.removeEventListener('offline', () => handleEvents(false));
    };
  }, [online]);
  const screenWidth  = window.outerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#972B38",
          colorLink: '#972B38',
          colorLinkActive: '#3c3c3c',
          colorLinkHover: '#3c3c3c',
          colorError: "#972B38",
          colorBorder: "#949494",
          colorSuccess: "#23d100",
          colorWarning: "#fcb921",
          borderRadius: 4,
          fontFamily: "'Roboto', sans-serif",
          fontSize: screenWidth < 1500 ? 12 : 14
        },
      }}
    >
      {!online && (
        <div className="offline-state">
          <Result
            status="error"
            icon={<DisconnectOutlined />}
            title={<h1 aria-live="polite">You have no Internet</h1>}
            subTitle="The network connection is lost. Please wait for sometime."
          />
        </div>
      )}
      <ErrorBoundary>
        <AppRoute />
        <Prompt />
      </ErrorBoundary>
    </ConfigProvider>
  );
}

export default App;
